import { GET_SLOTS } from '../actions/slotPlanner/slotPlanner.actiontype';

const initialState = {
  slots: [],
};

const SlotPlanner = (state = initialState, action) => {
  switch (action.type) {
    case GET_SLOTS: {
      return {
        ...state,
        slots: action.payload,
      };
    }

    default:
      return state;
  }
};

export default SlotPlanner;

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
